import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "card-outlined py-2 px-4 mb-5" }
const _hoisted_3 = { class: "flex items-center mb-8" }
const _hoisted_4 = { class: "flex-1 whitespace-pre-wrap text-2xl md:text-3xl" }
const _hoisted_5 = { class: "whitespace-pre-wrap mb-6" }
const _hoisted_6 = { class: "card-outlined py-2 px-4" }
const _hoisted_7 = { class: "flex items-center mb-8" }
const _hoisted_8 = { class: "flex-1 whitespace-pre-wrap text-2xl md:text-3xl" }
const _hoisted_9 = { class: "whitespace-pre-wrap mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.qa_details)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_base_svg_icon, {
                        class: "w-12 md:w-14 text-blue-500 mr-2",
                        path: _ctx.mdiHelpCircle
                      }, null, 8, ["path"]),
                      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.qa_details.question_title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.qa_details.question_body), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_base_svg_icon, {
                        class: "w-12 md:w-14 text-yellow-500 mr-2",
                        path: _ctx.mdiLightbulbOn70
                      }, null, 8, ["path"]),
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.qa_details.answer_title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.qa_details.answer_body), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" ページが見つかりませんでした。 ")
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}